import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import GreetingUser from '../../utils/greetingUser';
import AtomicDrawer from '../../atomic/drawer/AtomicDrawer';
import MenuTabsHeaders from './MenuTabsHeader';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from '../../utils/getUrls';
import './header.scss';
import StoreOperationStatus from './StoreOperationStatus';

const Header = () => {
  const navigate = useNavigate();

  const {
    isLoggedIn,
    selectedMenuTab,
    setSelectedMenuTab,
    setisLoggedIn,
    newPendingOrder,
    preparingOrder,
    setPreparingOrder,
    orderReadyForPickup,
    setOrderReadyForPickup,
    scheduledOrder,
    setScheduledOrder,
    openOrderAlert,
    setOpenOrderAlert,
    allOrders,
    setAllOrders,
    onLoadInfoResponse,
    inHouseDeliveryOrders,
  } = useContext(GlobalStateDataContext);

  const KitchenOperations = onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject;
  const checkUrl = getUrlPath() === '/';

  const RedirectPage = async () => {
    if (checkUrl) {
      return;
    }

    if (checkUrl === false) {
      await navigate('/');
    }
  };

  const BtnStyle = {
    color: '#ececec',
    margin: '0px 10px 0px 10px',
    fontSize: '15px',
    fontFamily: 'Inter Regular',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  };

  const BtnSelectedStyle = {
    color: '#181436',
    margin: '0px 5px 0px 10px',
    fontSize: '15px',
    fontFamily: 'Inter Bold',
    backgroundColor: 'white',
    border: '2px solid white',
    borderRadius: '3px',
    padding: '2px 8px 2px 8px',
    cursor: 'pointer',
  };

  return (
    <header
      style={{
        height: 50,
        // backgroundColor: 'hwb(23 16% 0%)',
        // width: '100%',
        backgroundColor: '#181436',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'sticky',
        top: 0,
        borderBottom: '2px solid hwb(23 16% 0%)',
        zIndex: 12,
      }}
    >
      <div
        style={{
          display: 'flex',
          maxWidth: '2200px',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Badge
            badgeContent={newPendingOrder?.length}
            color='primary'
            showZero={false}
            className='badge-style'
          >
            <button
              style={selectedMenuTab === 'action' ? BtnSelectedStyle : BtnStyle}
              onClick={() => {
                setSelectedMenuTab('action');
                RedirectPage();
              }}
            >
              {'Action'}
            </button>
          </Badge>

          <Badge
            badgeContent={preparingOrder?.length}
            color='primary'
            showZero={false}
            className='badge-style-lightblue'
          >
            <button
              style={selectedMenuTab === 'inprogress' ? BtnSelectedStyle : BtnStyle}
              onClick={() => {
                setSelectedMenuTab('inprogress');
                RedirectPage();
              }}
            >
              {'In Progress'}
            </button>
          </Badge>

          <Badge
            badgeContent={orderReadyForPickup?.length}
            color='primary'
            showZero={false}
            className='badge-style-lightblue'
          >
            <button
              style={selectedMenuTab === 'orderReady' ? BtnSelectedStyle : BtnStyle}
              onClick={() => {
                setSelectedMenuTab('orderReady');
                RedirectPage();
              }}
            >
              {'OrderReady'}
            </button>
          </Badge>

          <Badge
            badgeContent={scheduledOrder?.length}
            color='primary'
            showZero={false}
            className='badge-style-lightblue'
          >
            <button
              style={selectedMenuTab === 'scheduled' ? BtnSelectedStyle : BtnStyle}
              onClick={() => {
                setSelectedMenuTab('scheduled');
                RedirectPage();
              }}
            >
              {'Scheduled'}
            </button>
          </Badge>

          <button
            style={selectedMenuTab === 'allorders' ? BtnSelectedStyle : BtnStyle}
            onClick={() => {
              setSelectedMenuTab('allorders');
              RedirectPage();
            }}
          >
            {'All Orders'}
          </button>

          <Badge
            badgeContent={inHouseDeliveryOrders?.length}
            color='primary'
            showZero={false}
            className='badge-style-verylightblue'
          >
            <button
              style={selectedMenuTab === 'restaurantdelivery' ? BtnSelectedStyle : BtnStyle}
              onClick={() => {
                setSelectedMenuTab('restaurantdelivery');
                RedirectPage();
              }}
            >
              {'In-House Delivery'}
            </button>
          </Badge>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <StoreOperationStatus />

          <AtomicDrawer>
            <MenuTabsHeaders />
          </AtomicDrawer>
        </div>
      </div>
    </header>
  );
};

export default Header;
